/**
 * InspectNotFound — fallback for unknown sub-region IDs in Atlas inspect
 * routing. Per Atlas Day 2.5 P1 EngineAtlasInspectRouter.
 *
 * Renders within InspectShell so breadcrumb + ESC + browser back all work
 * the same way as actual inspect views. Subtle "not here" framing per
 * Atlas Day 2.5 build prompt §1 — not an error banner, just acknowledges
 * that the URL didn't match a registered inspect view.
 */

import type { JSX } from 'react';
import InspectShell from './InspectShell';

export interface InspectNotFoundProps {
  subRegionId?: string;
}

export default function InspectNotFound({ subRegionId }: InspectNotFoundProps): JSX.Element {
  return (
    <InspectShell subRegionName="Inspect view not found">
      <p className="text-sm text-ink-muted">
        No inspect view registered for{' '}
        <code className="text-ink-secondary">{subRegionId ?? '(unknown)'}</code>. Use the
        breadcrumb to return to Engine Atlas.
      </p>
    </InspectShell>
  );
}
